import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { AuthGuard } from './_helpers';
import { PageNotFoundComponent }    from './page-not-found/page-not-found.component';
import { ContentRechargeComponent }  from './content-recharge/content-recharge.component';   
import {FAQComponent}     from './faq/faq.component';
import {ContactComponent} from './contact/contact.component';
import {SupportComponent} from './support/support.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { AboutUsComponent} from './about-us/about-us.component';
import { ProfileComponent} from './profile/profile.component';
import {MyOrderComponent} from './my-order/my-order.component';

const routes: Routes = [
    { path: '', component: ContentRechargeComponent },
   // {path: '',      component: ContentRechargeComponent,canActivate: [AuthGuard] },
    {path: 'login', component: LoginComponent },
    {path: 'faq',   component: FAQComponent },
    {path: 'contact',   component: ContactComponent },
    {path :'support', component:SupportComponent},
    {path :'privacy-policy', component:PrivacyPolicyComponent},
    {path :'terms-and-conditions', component:TermsAndConditionsComponent},
    {path :'about-us', component : AboutUsComponent},
    {path : 'profile', component: ProfileComponent,canActivate: [AuthGuard]},
    {path : 'my-order',component:MyOrderComponent,canActivate: [AuthGuard]},
    {path: '**', component: PageNotFoundComponent }, 
    // otherwise redirect to home
    // { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
